import {
  BarChartData,
  ChartBuilder,
} from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { parseUserUtilizationPayload } from '../payloads/userUtilizationPayload';
import intl from 'react-intl-universal';

export const buildUserUtilizationInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseUserUtilizationPayload(payload);

  const data = parsedPayload.data.attributes.data;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.H_BAR_STACK)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisOptions: {
          min: 0,
          max: 100,
          label: {
            align: 'center',
            formatter: (value: unknown) => `${value}%`,
          },
        },
        drillDownKeys: {
          categoryAxis: ['user_name'],
          valueAxis: ['task_utilization', 'event_utilization'],
        },
        gridPadding: [undefined, 20, undefined, undefined],
        yAxisFieldName: 'user_name',
        xAxisFieldNames: [
          'task_utilization_percent',
          'event_utilization_percent',
        ],
        stackTotalFieldName: 'overall_utilization_percent',
        legendNames: [
          intl.get('INSIGHT.LEGEND.TASK_UTILIZATION_PERCENT'),
          intl.get('INSIGHT.LEGEND.EVENT_UTILIZATION_PERCENT'),
        ],
        stacks: ['utilization', 'utilization'],
        barAxisName: intl.get('INSIGHT.AXIS.UTILIZATION_RATE'),
        yAxisName: intl.get('INSIGHT.AXIS.UTILIZATION_BY_USERS'),
        markLines: data.map((d) => d.target_utilization_percent),
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
